export default __webpack_public_path__ + "static/media/testimonal-card.35fae096.JPG";